import React from 'react';
import { useToast } from '@common/toast';
import ConfirmModal from '@components/mypage/premium/confirmModal';
import { useDeletePartnershipUser } from '@repository/partnership/usePartnership';
import { PARTNERSHIP_TYPE } from '@domain/rs/alliance/AffiliateListRs';
import useModal from '@utils/hooks/useModal';
import classnames from 'classnames/bind';
import styles from './premium.module.scss';

const cx = classnames.bind(styles);

interface CertRemoveButtonProps {
  onClick: () => void;
  partnershipType: PARTNERSHIP_TYPE;
}

const CertRemoveButton = ({ onClick, partnershipType }: CertRemoveButtonProps) => {
  const Toast = useToast();
  const { openModal, closeModal, isModalOpen } = useModal();
  const { mutateAsync: deletePartnerShipUser } = useDeletePartnershipUser({
    onSuccess: () =>
      Toast({
        iconType: 'check',
        type: 'success',
        content: '인증정보가 삭제되었습니다.',
      }),
  });

  const handleClick = async () => {
    await deletePartnerShipUser(partnershipType);
    onClick();
    closeModal();
  };

  return (
    <>
      <button className={cx('btnSave', 'delete')} type={'button'} onClick={openModal}>
        인증정보 삭제
      </button>

      <ConfirmModal visible={isModalOpen} onClick={handleClick} onClose={closeModal} />
    </>
  );
};

export default CertRemoveButton;
